<template>
    <c-modal
            v-model="model"
            cancel-label="No, Never mind"
            centered
            title="Log Out"
            :tag="false"
            confirm-label="Proceed with Log Out"
            :progressing="loading"
            size="md"
            @submit="logout"
    >
        <template>
            Are you sure you want to log out?
        </template>
    </c-modal>
</template>

<script>
    import CModal from "./Cmodal";
    import config from 'SrcConfig'
    import * as types from '@/store/types'
    export default {
        name: "logout",
        components: {CModal},
        props: {
            value: {
                required: true
            }
        },
        data () {
            return {
                loading: false
            }
        },

        computed: {
            model: {
                get () {
                    return this.value
                },
                set (val) {
                    this.value = val
                }
            }
        },
        methods: {
            logout () {
                this.loading = true
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    UserID: localStorage.getItem('userID')
                }
                if(model.UserID === null){//we changed from userid based auth to header based if userid is null we req for it here first
                    return this.$api.getRestaurant.getList().then(res=>{
                        model.UserID = res.results.UserID
                        this.$api.getRestaurant.GetLogOut(model).then(res => {
                            if (res.success) {
                                this.loading = false
                                this.$store.commit(types.LOGOUT)
                                localStorage.clear()
                                sessionStorage.clear()
                                this.$router.push('/')
                                // window.location.assign(`${config.redirectToHome}/?auth=0`)
                            } else {
                                this.loading = false
                                this.$showError(res.message)
                            }
                        }).catch(() => {
                            this.loading = false
                        })
                    })
                }

                
                this.$api.getRestaurant.GetLogOut(model).then(res => {
                    if (res.success) {
                        this.loading = false
                        this.$store.commit(types.LOGOUT)
                        localStorage.clear()
                        sessionStorage.clear()
                        this.$router.push('/')
                        // window.location.assign(`${config.redirectToHome}/?auth=0`)
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>

</style>
